import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetProductByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
  is_not_deleted: Types.Scalars['Boolean']['input'];
}>;


export type GetProductByIdQuery = { __typename?: 'query_root', products_by_pk: Array<{ __typename?: 'products', id: any, name: string, description: string, sku?: string | null, make: string, model: string, retail_price?: any | null, extended_price?: any | null, product_notes?: string | null, workspace_id?: any | null, organization_id?: any | null, photo_link?: string | null, parent_product_id?: any | null, partition_id?: string | null, product_category: { __typename?: 'product_categories', name: string, label: string }, installed_products: Array<{ __typename?: 'installed_products', id: any, location?: string | null, photo_link?: string | null, installation_date: any, product_serial?: string | null, device_status?: string | null, partner_disconnected_at?: any | null, partner_association?: string | null, property?: { __typename?: 'properties', id: any, name: string } | null }>, parent_product?: { __typename?: 'products', id: any, name: string, make: string, model: string, description: string } | null, product_attachments: Array<{ __typename?: 'product_attachments', id: any, photo_link?: string | null, document_link?: string | null, video_link?: string | null, audio_link?: string | null, site_link?: string | null, transcription?: string | null, transcribed: boolean, type?: string | null, description?: string | null, name?: string | null }> }> };


export const GetProductByIdDocument = gql`
    query getProductById($id: uuid!, $is_not_deleted: Boolean!) {
  products_by_pk: products(
    where: {id: {_eq: $id}, deleted_at: {_is_null: $is_not_deleted}}
  ) {
    id
    name
    description
    sku
    product_category {
      name
      label
    }
    make
    model
    retail_price
    extended_price
    product_notes
    workspace_id
    organization_id
    photo_link
    parent_product_id
    partition_id
    installed_products(where: {deleted_at: {_is_null: $is_not_deleted}}) {
      id
      location
      photo_link
      property {
        id
        name
      }
      installation_date
      product_serial
      device_status
      partner_disconnected_at
      partner_association
    }
    parent_product {
      id
      name
      make
      model
      description
    }
    product_attachments(order_by: {created_at: asc}) {
      id
      photo_link
      document_link
      video_link
      audio_link
      site_link
      transcription
      transcribed
      type
      description
      name
    }
  }
}
    `;

/**
 * __useGetProductByIdQuery__
 *
 * To run a query within a React component, call `useGetProductByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      is_not_deleted: // value for 'is_not_deleted'
 *   },
 * });
 */
export function useGetProductByIdQuery(baseOptions: Apollo.QueryHookOptions<GetProductByIdQuery, GetProductByIdQueryVariables> & ({ variables: GetProductByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductByIdQuery, GetProductByIdQueryVariables>(GetProductByIdDocument, options);
      }
export function useGetProductByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductByIdQuery, GetProductByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductByIdQuery, GetProductByIdQueryVariables>(GetProductByIdDocument, options);
        }
export function useGetProductByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductByIdQuery, GetProductByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductByIdQuery, GetProductByIdQueryVariables>(GetProductByIdDocument, options);
        }
export type GetProductByIdQueryHookResult = ReturnType<typeof useGetProductByIdQuery>;
export type GetProductByIdLazyQueryHookResult = ReturnType<typeof useGetProductByIdLazyQuery>;
export type GetProductByIdSuspenseQueryHookResult = ReturnType<typeof useGetProductByIdSuspenseQuery>;
export type GetProductByIdQueryResult = Apollo.QueryResult<GetProductByIdQuery, GetProductByIdQueryVariables>;